import { Box } from "@chakra-ui/react";
import GeoFenced from "@components/GeoFenced";
import type { NextPage } from "next";

const Blocked: NextPage = () => {
  return (
    <Box>
      <GeoFenced />
    </Box>
  );
};

export default Blocked;
